// extracted by mini-css-extract-plugin
module.exports = {"header":"Donut_header__1l05z","donut":"Donut_donut__2Oj95"};